<template>
  <modal-layer
    modal-id="course-modal-frame"
    :item-id="courseItem.id"
    :position="courseItem.course_name"
    :show-arrows="showArrows"
    :loading="iframeLoad"
    @reset-data="resetData"
    @next="nextIterator"
    @prev="prevIterator"
  >
    <iframe
      title="course-iframe"
      :src="courseItem.url"
      width="100%"
      height="100%"
      @load="iframeLoad = false"
      frameborder="0"
      id="modalCourseIframe"
      allowfullscreen
    ></iframe>
  </modal-layer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { CourseModalModule } from '@/store/modules/courses/courseModal';
import ModalLayer from '@/components/Modals/ModalLayer.vue';

@Component({
  components: {
    'modal-layer': ModalLayer,
  },
})
export default class ModalCourseInfo extends Vue {
  iframeLoad = true;

  get showArrows() {
    return CourseModalModule.courseListForModal.length > 1;
  }

  get courseItem() {
    return CourseModalModule.currentCourse;
  }

  async resetData() {
    await CourseModalModule.UPDATE_CURRENT_COURSE_INDEX();
    CourseModalModule.UPDATE_CURRENT_COURSE();
    CourseModalModule.UPDATE_CURRENT_COURSES_LIST();
  }

  nextIterator() {
    this.iframeLoad = true;
    CourseModalModule.SHOW_NEXT_COURSE();
  }

  prevIterator() {
    this.iframeLoad = true;
    CourseModalModule.SHOW_PREV_COURSE();
  }

  hideAllTooltips() {
    // fix for mobile devices
    this.$root.$emit('bv::hide::tooltip');
  }
}
</script>
